exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_contentOrganizerPanel_2_YL0xfhv5rl3HBf8M7jqO {\n  padding: 40px;\n}", ""]);

// Exports
exports.locals = {
	"IA_contentOrganizerPanel": "IA_contentOrganizerPanel_2_YL0xfhv5rl3HBf8M7jqO"
};